import { Injectable, effect, inject } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { RangeDatepickerComponent, PresetItem, DatepickerRange } from '@ui/aos-lib';
import { selectAlarmsDateRange, selectHistoryLogDateRange } from './store/health-monitor.reducer';

@Injectable({ providedIn: 'root' })
export class HealthMonitorDateRangeService {
  private fb = inject(FormBuilder);
  readonly #store = inject(Store);

  readonly #alarmsDateRange = this.#store.selectSignal(selectAlarmsDateRange);
  readonly #historyLogDateRange = this.#store.selectSignal(selectHistoryLogDateRange);

  public form: FormGroup | null = null;

  get alarmsStatisticsControl(): AbstractControl | null {
    return this.form?.get('alarmsStatisticsCtrl') ?? null;
  }

  get historyLogControl(): AbstractControl | null {
    return this.form?.get('historyLogCtrl') ?? null;
  }

  get preset(): PresetItem[] {
    return [
      RangeDatepickerComponent.TODAY,
      RangeDatepickerComponent.YESTERDAY,
      RangeDatepickerComponent.LAST_WEEK,
      RangeDatepickerComponent.LAST_TWO_WEEK,
      RangeDatepickerComponent.LAST_MONTH,
      RangeDatepickerComponent.LAST_THREE_MONTHS,
      RangeDatepickerComponent.LAST_YEAR
    ];
  }

  constructor() {
    effect(() => {
      const alarmsDateRange = this.#alarmsDateRange();
      const historyLogDateRange = this.#historyLogDateRange();
      if (alarmsDateRange && historyLogDateRange && !this.form) {
        this.form = this.fb.group({
          alarmsStatisticsCtrl: this.fb.nonNullable.control({
            start: new Date(alarmsDateRange.start),
            end: new Date(alarmsDateRange.end)
          }),
          historyLogCtrl: this.fb.nonNullable.control({
            start: new Date(historyLogDateRange.start),
            end: new Date(historyLogDateRange.end)
          })
        });
      }
    });
  }

  createDefaultDateRange(): DatepickerRange {
    return {
      start: new Date((RangeDatepickerComponent.LAST_MONTH.getValue() as DatepickerRange).start),
      end: new Date((RangeDatepickerComponent.LAST_MONTH.getValue() as DatepickerRange).end)
    };
  }
}
